var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZip(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-ecdaeb8a-f299-4304-95d0-528039695f87",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38.45 31.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-9d8e01c1-b486-4847-935d-e9efd5868e27 {\n        fill: #fff;\n      }\n\n      .uuid-9b1dbdee-ff60-4402-9833-99f3a77ad1f2 {\n        fill: gray;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uuid-3b61ea4d-091c-4561-98e6-a168b5bf041c",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "uuid-9b1dbdee-ff60-4402-9833-99f3a77ad1f2",
    d: "m0,5.75v20.11c0,3.17,2.57,5.75,5.75,5.75h20.11c3.17,0,5.75-2.57,5.75-5.75v-3.92c0-.5-.35-.95-.85-1.03-2.46-.41-4.33-2.54-4.33-5.11,0-2.57,1.87-4.7,4.33-5.11.5-.08.85-.53.85-1.03v-3.92c0-3.17-2.57-5.75-5.75-5.75H5.75C2.57,0,0,2.57,0,5.75Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-9b1dbdee-ff60-4402-9833-99f3a77ad1f2",
    x: 31.53,
    y: 11.41,
    width: 5.07,
    height: 8.77,
    rx: 2.54,
    ry: 2.54,
    transform: "translate(18.26 49.86) rotate(-90)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "uuid-9d8e01c1-b486-4847-935d-e9efd5868e27",
    d: "m5.77,15.8h.56c1.27,0,2.31,1.03,2.31,2.31v2.87h-2.87c-1.27,0-2.31-1.03-2.31-2.31v-.56c0-1.27,1.03-2.31,2.31-2.31Z",
    transform: "translate(-12.34 24.44) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9d8e01c1-b486-4847-935d-e9efd5868e27",
    d: "m8.64,10.62h2.87c1.27,0,2.31,1.03,2.31,2.31v.56c0,1.27-1.03,2.31-2.31,2.31h-2.87v-5.18h0Z",
    transform: "translate(-1.98 24.44) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9d8e01c1-b486-4847-935d-e9efd5868e27",
    d: "m16.13,15.8h2.87v5.18h-2.87c-1.27,0-2.31-1.03-2.31-2.31v-.56c0-1.27,1.03-2.31,2.31-2.31Z",
    transform: "translate(-1.98 34.8) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9d8e01c1-b486-4847-935d-e9efd5868e27",
    d: "m19,10.62h2.87c1.27,0,2.31,1.03,2.31,2.31v.56c0,1.27-1.03,2.31-2.31,2.31h-.56c-1.27,0-2.31-1.03-2.31-2.31v-2.87h0Z",
    transform: "translate(8.37 34.8) rotate(-90)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZip);
export default __webpack_public_path__ + "static/media/zip.d2102fc4e0fca35938b71e3e2c9d2be2.svg";
export { ForwardRef as ReactComponent };